import React, { useEffect, useMemo } from "react";
import LeafletHeatmap from "leaflet-heatmap";
import MapConfig from "services/map/MapConfig";

type Props = {
  map: object;
  points: { position: {}; occupancy: number }[];
  options: {
    background_color: string;
    blur: string;
    gradient: string;
    radius: number;
    min_opacity: number;
    max_opacity: number;
    opacity: number;
  };
};

function HeatmapLayer({ map, points, options }: Props): JSX.Element {
  const heatmapLayer = useMemo(() => {
    return new LeafletHeatmap({
      backgroundColor:
        options?.background_color ||
        MapConfig?.heatmap?.config?.backgroundColor,
      gradient: options?.gradient || MapConfig?.heatmap?.config?.gradient,
      radius: options?.radius || MapConfig?.heatmap?.config?.radius,
      minOpacity:
        options?.min_opacity || MapConfig?.heatmap?.config?.minOpacity,
      blur: options?.blur || MapConfig?.heatmap?.config.blur,
      opacity: options?.opacity || MapConfig?.heatmap?.config?.opacity,
      maxOpacity:
        options?.max_opacity || MapConfig?.heatmap?.config?.maxOpacity,
      scaleRadius: true,
      useLocalExtrema: false,
      latField: "lat",
      lngField: "lng",
      valueField: "occupancy",
    });
    // eslint-disable-next-line
  }, [map]);

  const data = useMemo(() => {
    return {
      max: 1,
      data: points.map(({ position, occupancy }) => ({
        ...position,
        occupancy: occupancy + 0.01,
      })),
    };
  }, [points]);

  useEffect(() => {
    heatmapLayer.addTo(map);
    heatmapLayer.setData(data);
    return () => {
      heatmapLayer.removeFrom(map);
    };
  }, [heatmapLayer, data, map]);

  return <></>;
}

export default HeatmapLayer;
